import React, { Component } from "react";
import { Paper, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import { withTheme, withStyles } from "@material-ui/core/styles";
import FormViewer from "./FormViewer";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withHistory, withModulesManager } from "@openimis/fe-core";
import { fetchAccreditationDetailForms, fetchQADetailForms, approveDetailFormDataEntry } from "../actions";
import PropTypes from "prop-types";
import { graphql } from "@openimis/fe-core";

const styles = (theme) => ({
  page: theme.page,
  paper: theme.paper.paper,
  title: theme.paper.title,
  formContainer: {
    marginTop: theme.spacing(1),
  },
});

class QualityAssuranceDataView extends Component {
  state = {
    open: false,
    selectedForm: null,
    forms: [],
    formData: {},
  };

  // componentDidMount() is fetching data from the server
  componentDidMount() {
    const { edited, detailType, fetchAccreditationDetailForms, fetchQADetailForms } = this.props;

    if (edited && Array.isArray(edited) && edited.length > 0 && detailType === "acc") {
      fetchAccreditationDetailForms(edited?.id);
    } else if (edited && edited.id) {
      fetchQADetailForms(edited.id);
    } else {
      console.error("Error: Missing edited object or ID.");
    }
  }

  // componentDidUpdate() updates the state when new props are received
  componentDidUpdate(prevProps) {
    const {
      approveSuccess,
      approveError,
      approvingForm,
      fetchedAccreditationDetailsForms,
      accreditationDetailsForms,
      fetchedQADetailsForms,
      qaDetailsForms,
    } = this.props;
    const { validating, selectedForm } = this.state;
    if (prevProps.approvingForm && !approvingForm && validating) {
      console.log("Validation result - approveSuccess:", approveSuccess);
      if (approveSuccess) {
        const { dispatch, edited } = this.props;
        const { selectedForm } = this.state;

        this.setState(
          {
            validating: false,
            validationSuccess: true,
            validationError: null,
          },
          () => {
            // ✅ Dispatch validated form to Redux
            dispatch({
              type: "QA_FORM_VALIDATED",
              payload: {
                qualityAssuranceId: edited?.id || edited?.id,
                // formId: selectedForm.id,
                uuid: selectedForm.uuid,
                submitedData: true,
              },
            });

            // ✅ Remove reload, or keep it only if necessary
            // setTimeout(() => window.location.reload(), 1000);
          },
        );
      } else if (approveError) {
        this.setState({
          validating: false,
          validationSuccess: false,
          validationError: approveError,
        });
      }
    }
    if (
      prevProps.fetchedAccreditationDetailsForms !== fetchedAccreditationDetailsForms &&
      fetchedAccreditationDetailsForms
    ) {
      this.setState({
        forms: accreditationDetailsForms,
      });
    }
    if (prevProps.fetchedQADetailsForms !== fetchedQADetailsForms && fetchedQADetailsForms) {
      this.setState({ forms: qaDetailsForms });
      console.log("QA forms loaded:", this.state.forms);
    }
    const newRawData = this.props?.qaDetailsFormData?.data;
    const prevRawData = prevProps?.qaDetailsFormData?.data;

    console.log("componentDidUpdate called with:", this.props.qaDetailsFormData);
    console.log("Redux full state:", this.props.core);
    console.log("New Raw data", newRawData);
    console.log("Pre Raw data", prevRawData);

    // Only parse if the new raw data exists and changed
    if (newRawData && newRawData !== prevRawData) {
      console.log("New form data detected:", newRawData);

      try {
        const outerParsed = JSON.parse(newRawData);
        const firstValue = outerParsed?.value;

        if (firstValue && typeof firstValue === "object") {
          console.log("Parsed formData successfully:", firstValue);
          this.setState({ formData: firstValue, hasFormData: true });
        } else {
          console.warn("No valid data in 'value':", outerParsed);
          this.setState({ formData: {}, hasFormData: false });
        }
      } catch (error) {
        console.error("Error parsing form data:", error);
        this.setState({ formData: {}, hasFormData: false });
      }
    }
  }

  // Open the dialog with the selected form
  handleOpen = (form) => {
    this.setState({
      open: true,
      selectedForm: form,
      validationSuccess: false,
      validationError: null,
      formData: {},
    });

    this.checkFormData(form.uuid);
  };

  // Close the dialog
  handleClose = () => {
    this.setState({
      open: false,
      selectedForm: null,
      validationSuccess: false,
      validationError: null,
      hasFormData: false,
      formData: {},
    });
  };

  checkFormData = (uuid) => {
    if (!uuid) return;

    const { detailType } = this.props;
    const detailTypeValue = detailType === "qa" ? "qa" : "ACC";

    const query = `
      query {
        projectDetailFormData(
          projectDetailFormUuid: "${uuid}",
          projectDetailType: "${detailTypeValue}"
        ) {
          data
          
        }
      }
    `;

    this.props.dispatch(graphql(query, "QA_DETAILS_FORMDATA"));
  };

  // Handle form input changes
  handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: type === "checkbox" ? checked : value,
      },
      hasFormData: true,
    }));
  };

  handleValidate = () => {
    const { selectedForm, validating } = this.state;
    const { detailType, approveDetailFormDataEntry } = this.props;

    if (validating) return;

    if (!selectedForm) {
      console.error("No form selected for validation");
      return;
    }

    this.setState({ validating: true });

    const detailTypeValue = detailType === "qa" ? "QA" : "ACC";
    console.log("Submitting validation with:", {
      detailFormUuid: selectedForm.uuid,
      detailType: detailTypeValue,
    });

    approveDetailFormDataEntry(selectedForm.uuid, detailTypeValue, "QA Form  Detail Validated");
  };
  isFormDataAvailable = () => {
    const { formData } = this.state;
    if (!formData || typeof formData !== "object") return false;

    const dataKeys = Object.keys(formData).filter((key) => key !== "meta" && key !== "__id" && key !== "__system");

    return dataKeys.length > 0;
  };

  render() {
    const { classes, accreditationDetailsForms, qaDetailsForms, detailType } = this.props;
    const { open, selectedForm, forms, validating, validationSuccess, validationError, formData } = this.state;
    console.log("Form123", forms);

    const formHasData = this.isFormDataAvailable();
    console.log("formHasData:", formHasData);

    return (
      <div>
        <Paper className={classes.paper}>
          <Typography className={classes.title}>Quality Assurance Data View</Typography>
          <div className={classes.page}>
            {/* Render forms list */}
            {forms && forms.length > 0 ? (
              forms.map((form) => (
                <Typography
                  key={form.id}
                  variant="outlined"
                  color="primary"
                  onClick={() => this.handleOpen(form)}
                  style={{
                    margin: "10px",
                    display: "block",
                    cursor: "pointer",
                    border: "solid 1px",
                    borderRadius: "5px",
                    padding: 10,
                  }}
                >
                  {form?.odkForm.formName}
                </Typography>
              ))
            ) : (
              <Typography>No forms available</Typography>
            )}
          </div>
        </Paper>

        {/* Modal Component */}
        <Dialog open={open} onClose={this.handleClose} maxWidth="lg" fullWidth>
          <DialogTitle>{selectedForm ? selectedForm.odkForm.formName : "Select a Form"}</DialogTitle>
          <DialogContent className={classes.formContainer}>
            <FormViewer
              uuid={selectedForm?.uuid}
              detailType={detailType}
              onChange={this.handleInputChange}
              initialData={formData}
            />
            {validationSuccess && (
              <Typography color="primary" style={{ marginTop: 16, padding: 8, backgroundColor: "#e6f7ff" }}>
                Form validation successful!
              </Typography>
            )}

            {validationError && (
              <Typography color="error" style={{ marginTop: 16, padding: 8, backgroundColor: "#ffebee" }}>
                Error: {validationError}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleValidate}
              disabled={validating || validationSuccess || !formHasData}
            >
              {validating ? "Validating..." : validationSuccess ? "Validated" : "Validate"}
            </Button>

            <Button onClick={this.handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

QualityAssuranceDataView.propTypes = {
  classes: PropTypes.object.isRequired,
  detailType: PropTypes.string.isRequired,
  edited: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  fetchAccreditationDetailForms: PropTypes.func.isRequired,
  fetchQADetailForms: PropTypes.func.isRequired,
  accreditationDetailsForms: PropTypes.array.isRequired,
  qaDetailsForms: PropTypes.array.isRequired,
  fetchedAccreditationDetailsForms: PropTypes.bool.isRequired,
  fetchedQADetailsForms: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
  module: state.core?.savedPagination?.module,
  accreditationDetailsForms: state.quality_assurance_and_accreditation.accreditationDetailsForms,
  fetchingAccreditationDetailsForms: state.quality_assurance_and_accreditation.fetchingAccreditationDetailsForms,
  fetchedAccreditationDetailsForms: state.quality_assurance_and_accreditation.fetchedAccreditationDetailsForms,
  errorAccreditationDetailsForms: state.quality_assurance_and_accreditation.errorAccreditationDetailsForms,
  qaDetailsForms: state.quality_assurance_and_accreditation.qaDetailsForms,
  fetchingQADetailsForms: state.quality_assurance_and_accreditation.fetchingQADetailsForms,
  fetchedQADetailsForms: state.quality_assurance_and_accreditation.fetchedQADetailsForms,
  errorQADetailsForms: state.quality_assurance_and_accreditation.errorQADetailsForms,
  approveSuccess: state.quality_assurance_and_accreditation.approveSuccess,
  approveError: state.quality_assurance_and_accreditation.approveError,
  approvingForm: state.quality_assurance_and_accreditation.approvingForm,
  isProcessing: state.quality_assurance_and_accreditation.fetchingApproveDetailFormDataEntry,
  core: state.core,
  accreditationDetailsFormData: state.quality_assurance_and_accreditation.accreditationDetailsFormData,
  qaDetailsFormData: state.quality_assurance_and_accreditation.qaDetailsFormData,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({ fetchAccreditationDetailForms, fetchQADetailForms, approveDetailFormDataEntry }, dispatch),
  dispatch,
});

export default withModulesManager(
  injectIntl(
    withTheme(withStyles(styles)(withHistory(connect(mapStateToProps, mapDispatchToProps)(QualityAssuranceDataView)))),
  ),
);
